import { render, staticRenderFns } from "./EllipsisText.vue?vue&type=template&id=3ecbb5a7&scoped=true"
import script from "./EllipsisText.vue?vue&type=script&lang=js"
export * from "./EllipsisText.vue?vue&type=script&lang=js"
import style0 from "./EllipsisText.vue?vue&type=style&index=0&id=3ecbb5a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecbb5a7",
  null
  
)

export default component.exports